import { Accordion } from '@/components/common/Accordion';
import { CardsContainer } from '@/components/dashboard/DashboardCard';
import InvitePatient from '@/components/dashboard/users/InvitePatient';
import RestrictedUsersRow from '@/components/dashboard/users/restrict-user/RestrictedUsersRow';
import ShowPatients from '@/components/dashboard/users/show-patient/ShowPatients';
import ShowInvitedDoctors from '@/components/dashboard/users/ShowInvitedDoctors';
import ShowInvitedPatients from '@/components/dashboard/users/ShowInvitedPatients';
import DiscountUsersRow from '@/components/dashboard/users/users-discount/DiscountUsersRow';
import UsersRow from '@/components/dashboard/users/users-row/UsersRow';
import UserWarnings from '@/components/dashboard/users/users-warnings/UserWarnings';
import { Role } from '@/domain/Role';
import { useHasRole } from '@/hooks/useHasRole';
import { cn } from '@/lib/cn';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { useState } from 'react';

export const UsersPage = () => {
  const { isDesktop, isBigDesktop } = useBreakpoint();
  const { hasRole } = useHasRole();
  const doctor = hasRole(Role.DOCTOR);
  const shopAdmin = hasRole(Role.SHOP_ADMIN);
  const superAdmin = hasRole(Role.SUPERADMIN);
  const salesManager = hasRole(Role.SALES_MANAGER);
  const [accordionValue, setAccordionValue] = useState('');

  return (
    <div className="px-0 py-12.5 md:px-4">
      <CardsContainer
        className={cn(
          'md:rounded-0 pt-8 lg:max-w-305 lg:rounded-3xl xl:w-full',
          isBigDesktop ? 'mx-auto' : isDesktop ? 'mx-2' : 'mx-0',
        )}
      >
        <Accordion
          type="single"
          collapsible
          value={accordionValue}
          onValueChange={setAccordionValue}
          className="w-full space-y-4 border-none"
        >
          {(doctor || shopAdmin || superAdmin || salesManager) && (
            <InvitePatient />
          )}
          {(doctor || shopAdmin || superAdmin || salesManager) && (
            <ShowPatients accordionOpenValue={accordionValue} />
          )}
          {(doctor || shopAdmin || superAdmin || salesManager) && (
            <ShowInvitedPatients />
          )}
          {(shopAdmin || superAdmin) && <ShowInvitedDoctors />}
          {(shopAdmin || superAdmin) && <UserWarnings />}
          {(shopAdmin || superAdmin) && (
            <UsersRow accordionOpenValue={accordionValue} />
          )}
          {(shopAdmin || superAdmin) && (
            <RestrictedUsersRow accordionOpenValue={accordionValue} />
          )}
          {(shopAdmin || superAdmin || salesManager) && (
            <DiscountUsersRow accordionOpenValue={accordionValue} />
          )}
        </Accordion>
      </CardsContainer>
    </div>
  );
};
